/* global $ */
import React, { useState } from "react";
import DataTable from 'react-data-table-component';
import axios from "axios";
import Swal from 'sweetalert2';
import { useEffect } from "react";

function Superdealer() {
    const [registrationno, setRegistrationno] = useState('');
    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [newRecord, setNewRecord] = useState({
        date: "",
        reg_no: "",
        year: "",
        model: "",
        showroom: "",
        person: "",
        phone: "",
        price: "",
        expense: "",
        job_details: "",
        vehicle_case: "",
    });

    const [errors, setErrors] = useState({
        date: "",
        reg_no: "",
        year: "",
        model: "",
        showroom: "",
        person: "",
        phone: "",
        price: "",
        expense: "",
        job_details: "",
        vehicle_case: "",
    });

    const fetchData = async () => {
        try {
            const response = await axios.get(`https://api.sivammoto.in/api/superdealer/`);
            console.log(response.data);
            // Filter only active records
            const activeData = response.data.filter(item => item.isactive);
            setData(activeData);
        } catch (error) {
            console.error('Error fetching vehicle registration number data', error);
            const errorMessage =
                error.response?.data?.error ||
                error.response?.data?.message ||
                error.response?.statusText ||
                'An unknown error occurred';
            Swal.fire('Error!', `There was an issue in searching the registration records: ${errorMessage}`, 'error');
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setNewRecord(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAddButtonClick = () => {
        setIsEditMode(false);
        setEditingId(null);
        const today = new Date().toISOString().split("T")[0];
        setNewRecord({
            date: today,
            reg_no: "",
            year: "",
            model: "",
            showroom: "",
            person: "",
            phone: "",
            price: "",
            expense: "",
            job_details: "",
            vehicle_case: "",
        });
        setErrors({});
        $('#addRowModal').modal('show');
    };

    const handleEditButtonClick = (row) => {
        setIsEditMode(true);
        setEditingId(row.id);
        setNewRecord({
            date: row.date || "",
            reg_no: row.reg_no || "",
            year: row.year || "",
            model: row.model || "",
            showroom: row.showroom || "",
            person: row.person || "",
            phone: row.phone || "",
            price: row.price || "",
            expense: row.expense || "",
            job_details: row.job_details || "",
            vehicle_case: row.vehicle_case || "",
        });
        setErrors({});
        $('#addRowModal').modal('show');
    };

    const handleDeleteButtonClick = async (row) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to delete this Super Dealer record?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            try {
                const modified_by = localStorage.getItem('user_id');
                await axios.delete(`https://api.sivammoto.in/api/superdealer/delete/${row.id}`, {
                    data: { modified_by: modified_by }
                });
                
                await Swal.fire(
                    'Deleted!',
                    'The Super Dealer record has been deleted.',
                    'success'
                );
                
                fetchData();
            } catch (error) {
                console.error('Error deleting record:', error);
                const errorMessage = error.response?.data?.message || 'There was an issue deleting the record.';
                Swal.fire('Error!', errorMessage, 'error');
            }
        }
    };

    const validateForm = () => {
        let formErrors = {};

        if (!newRecord.reg_no) {
            formErrors.reg_no = "Registration Number is required";
        }

        if (!newRecord.price) {
            formErrors.price = "Price is required";
        }

        if (!newRecord.date) {
            formErrors.date = "Date is required";
        }

        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const user_id = localStorage.getItem('user_id');

        if (validateForm()) {
            setErrors({});
            try {
                const recordData = {
                    date: newRecord.date,
                    reg_no: newRecord.reg_no,
                    year: newRecord.year,
                    model: newRecord.model,
                    showroom: newRecord.showroom,
                    person: newRecord.person,
                    phone: newRecord.phone,
                    price: newRecord.price,
                    expense: newRecord.expense,
                    job_details: newRecord.job_details,
                    vehicle_case: newRecord.vehicle_case,
                };

                try {
                    if (isEditMode) {
                        // Update existing record
                        recordData.modified_by = user_id;
                        await axios.put(`https://api.sivammoto.in/api/superdealer/update/${editingId}`, recordData, {
                            headers: {
                                'Content-Type': 'application/json',
                            }
                        });
                        await Swal.fire('Updated!', 'The Super Dealer record has been updated.', 'success');
                    } else {
                        // Create new record
                        recordData.created_by = user_id;
                        await axios.post('https://api.sivammoto.in/api/superdealer/add', recordData, {
                            headers: {
                                'Content-Type': 'application/json',
                            }
                        });
                        await Swal.fire('Created!', 'The Super Dealer record has been created.', 'success');
                    }

                    fetchData();
                } catch (error) {
                    console.error('Error saving record:', error);
                    let errorMessage = 'There was an issue in saving the record.';
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Error!',
                        text: errorMessage,
                    });
                    return; // Don't close modal on error
                }

                $('#addRowModal').modal('hide').on('hidden.bs.modal', function () {
                    setTimeout(() => {
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                        $('body').css('padding-right', '');
                        $('body').css('overflow', '');
                    }, 500);
                });

                setNewRecord({
                    date: "",
                    reg_no: "",
                    year: "",
                    model: "",
                    showroom: "",
                    person: "",
                    phone: "",
                    price: "",
                    expense: "",
                    job_details: "",
                    vehicle_case: "",
                });
                setIsEditMode(false);
                setEditingId(null);

            } catch (error) {
                setErrors((prev) => ({ ...prev, form: error.message }));
            }
        }
    };

    $('#addRowModal').on('hidden.bs.modal', function () {
        $('#date').datetimepicker('clear');
        setNewRecord({
            date: "",
            reg_no: "",
            year: "",
            model: "",
            showroom: "",
            person: "",
            phone: "",
            price: "",
            expense: "",
            job_details: "",
            vehicle_case: "",
        });
        setIsEditMode(false);
        setEditingId(null);
        setErrors({});
    });

    const handleClear = () => {
        setRegistrationno('');
        setData([]);
    };

    const filteredData = data.filter(item =>
        (String(item.reg_no).toLowerCase().includes(searchText.toLowerCase())) ||
        (item.date && item.date.toLowerCase().includes(searchText.toLowerCase())) ||
        (item.model && item.model.toLowerCase().includes(searchText.toLowerCase())) ||
        (item.showroom && item.showroom.toLowerCase().includes(searchText.toLowerCase())) ||
        (item.dealer_details && item.dealer_details.toLowerCase().includes(searchText.toLowerCase()))
    );

    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>No</span>,
            selector: (row, index) => index + 1,
            sortable: true,
            width: '60px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Date</span>,
            selector: row => {
                if (!row?.date) return "";
                const date = new Date(row.date);
                return date.toLocaleDateString("en-GB");
            },
            sortable: true,
            width: '120px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Registration No</span>,
            selector: row => row.reg_no || "",
            sortable: true,
            width: '170px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Year</span>,
            selector: row => row?.year || "",
            sortable: true,
            width: '100px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Model</span>,
            selector: row => row?.model || "",
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Showroom</span>,
            selector: row => row?.showroom || "",
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Person</span>,
            selector: row => row?.person || "",
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Phone</span>,
            selector: row => row?.phone || "",
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Price</span>,
            selector: row => row?.price || "",
            sortable: true,
            width: '120px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Expense</span>,
            selector: row => row?.expense || "",
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Job Details</span>,
            selector: row => row?.job_details || "",
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Vehicle Case</span>,
            selector: row => row?.vehicle_case || "",
            sortable: true,
            width: '150px',
            style: {
                fontWeight: '800'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Actions</span>,
            cell: row => (
                <div className="d-flex gap-2">
                    <button
                        className="btn btn-sm btn-warning"
                        onClick={() => handleEditButtonClick(row)}
                        title="Edit"
                        style={{ marginRight: '8px' }}
                    >
                        <i className="fa fa-edit"></i>
                    </button>
                    <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDeleteButtonClick(row)}
                        title="Delete"
                    >
                        <i className="fa fa-trash"></i>
                    </button>
                </div>
            ),
            width: '120px',
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }
    ];

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Super Dealer Search</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Super Dealer Search</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-4">
                <div className="col d-flex justify-content-end">
                    <button
                        className="btn btn-primary mr-2"
                        onClick={handleAddButtonClick}
                    >
                        <i className="fa fa-plus" style={{ marginRight: '8px' }}></i>
                        Add Super Dealer
                    </button>
                </div>
            </div>

            {data && (
                <div className="row mb-2 mt-2">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    className="form-control mb-3"
                                />
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    pagination
                                    paginationPerPage={100}
                                    paginationRowsPerPageOptions={[100, 200, 300, 400]}
                                />

                                {/* Add/Edit Modal */}
                                <div className="modal fade" id="addRowModal">
                                    <div className="modal-dialog modal-lg">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title">
                                                    {isEditMode ? 'Edit Super Dealer' : 'Add Super Dealer'}
                                                </h4>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <form onSubmit={handleSubmit}>
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <label>Date</label>
                                                                <div className="input-group" id="date" data-target-input="nearest">
                                                                    <input
                                                                        id="date"
                                                                        type="date"
                                                                        value={newRecord.date || ''}
                                                                        onChange={(e) => setNewRecord(prev => ({ ...prev, date: e.target.value }))}
                                                                        className="form-control"
                                                                        data-target="#date"
                                                                    />
                                                                </div>
                                                                {errors.date && <small className="text-danger">{errors.date}</small>}
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <label>Registration No</label>
                                                                <input type="text" name="reg_no" value={newRecord.reg_no} onChange={handleInputChange} className="form-control" />
                                                                {errors.reg_no && <small className="text-danger">{errors.reg_no}</small>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <label>Year</label>
                                                                <input type="text" name="year" value={newRecord.year} onChange={handleInputChange} className="form-control" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <label>Model</label>
                                                                <input type="text" name="model" value={newRecord.model} onChange={handleInputChange} className="form-control" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <label>Showroom</label>
                                                                <input type="text" name="showroom" value={newRecord.showroom} onChange={handleInputChange} className="form-control" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <label>Person</label>
                                                                <input type="text" name="person" value={newRecord.person} onChange={handleInputChange} className="form-control" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <label>Phone</label>
                                                                <input type="text" name="phone" value={newRecord.phone} onChange={handleInputChange} className="form-control" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <label>Price</label>
                                                                <input type="text" name="price" value={newRecord.price} onChange={handleInputChange} className="form-control" />
                                                                {errors.price && <small className="text-danger">{errors.price}</small>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <label>Expense</label>
                                                                <input type="text" name="expense" value={newRecord.expense} onChange={handleInputChange} className="form-control" />
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <label>Job Details</label>
                                                                <input type="text" name="job_details" value={newRecord.job_details} onChange={handleInputChange} className="form-control" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-6">
                                                            <div className="form-group">
                                                                <label>Vehicle Case</label>
                                                                <input type="text" name="vehicle_case" value={newRecord.vehicle_case} onChange={handleInputChange} className="form-control" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="modal-footer justify-content-between">
                                                        <button type="submit" className="btn btn-primary">
                                                            {isEditMode ? 'Update' : 'Save changes'}
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Superdealer